import React from 'react';
import PropTypes from 'prop-types';

import SrLink from 'client/components/SrLink/SrLink';

const SrRenterApplicationStatusUpdatePetsRow = ({
  to,
}) => (
  <SrLink
    className='SrRenterApplicationStatusUpdatePetsRow'
    to={to}
  >
    <div className='actionContainer'>
      <span className='actionLink' />
    </div>
    <div className='textContainer'>
      <span className='addRoommate'>Edit or Add Pets</span>
      <span className='addRoommateMessage'>
        ESA &amp; service pets must be listed
      </span>
    </div>
  </SrLink>
);

SrRenterApplicationStatusUpdatePetsRow.propTypes = {
  to: PropTypes.string.isRequired,
};

SrRenterApplicationStatusUpdatePetsRow.displayName = 'SrRenterApplicationStatusUpdatePetsRow';

export default SrRenterApplicationStatusUpdatePetsRow;
